import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
  useRef,
} from 'react';
import moment from 'moment';

import SearchResult from './search_result';
import SearchForm from './search_form';

const SearchBox = (props) => {
  const [searchConditions, setSearchConditions] = useState({
    page: 1,
    prefKey: props.prefKey,
    keyword: props.keyword || '',
    circleOrder: props.circleOrder || '',
    eventCondition: props.eventCondition || '',
    eventDate: props.eventDate
      ? moment(props.eventDate).format('YYYY-MM-DD')
      : null,
    timeSlot: null,
    timeSlotFrom: null,
    timeSlotTo: null,
  });
  const [circles, setCircles] = useState([]);
  const [events, setEvents] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingNextList, setIsLoadingNextList] = useState(false);
  const [isLastPage, setIsLastPage] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  const scrollUpRef = useRef(null);

  React.useEffect(() => {
    apiCall(searchConditions)
  }, [])

  const apiCall = useCallback(
    ({ page, prefKey, keyword, circleOrder, eventCondition, eventDate, timeSlot, timeSlotFrom, timeSlotTo }) => {
      const data = {
        page,
        pref_key: prefKey,
        keyword,
        order: circleOrder,
        event_condition: eventCondition,
        event_date: eventDate,
        company_id: props.companyId || null,
      };
      if (timeSlot === 'custom') {
        data.time_slot = 'custom';
        data.time_slot_from = timeSlotFrom;
        data.time_slot_to = timeSlotTo;
      } else if (timeSlot) {
        data.time_slot = timeSlot;
      }
      $.ajax({
        url: '/api/circle/search/v2',
        dataType: 'json',
        cache: false,
        data,
        success: function (data) {
          // =========== 再描画 ===========
          const newCircles = data.circles !== undefined ? data.circles : [];
          const newEvents = data.events !== undefined ? data.events : [];
          if (page === 1) {
            // 1ページ目
            setCircles(newCircles);
            setEvents(newEvents);
            setTotalCount(data.totalCount);
            setBreadcrumbs(data.breadcrumbs);
          } else if (page >= 2) {
            // 2ページ目以降
            setCircles((prev) => [...prev, ...newCircles]);
            setEvents((prev) => [...prev, ...newEvents]);
          }
          setSearchConditions({
            page,
            prefKey,
            keyword,
            circleOrder,
            eventCondition,
            eventDate,
            timeSlot: timeSlot ?? null,
            timeSlotFrom: timeSlotFrom ?? null,
            timeSlotTo: timeSlotTo ?? null,
          });
          setIsLoading(false);
          setIsLoadingNextList(false);
          const isEventCondition =
            eventCondition === 'event' || eventCondition === '';
          const isLast =
            data.isLastPage || (isEventCondition && newEvents.length === 0);
          setIsLastPage(isLast);

          // =========== URL更新 ===========
          updateUrl({
            categoryId: data.categoryId,
            mainGenreKey: data.mainGenreKey,
            keyword: keyword,
            circleOrder,
            eventCondition,
            eventDate,
            page,
            prefKey,
          });
        },
        error: function () {
          setIsLoading(false);
          setIsLoadingNextList(false);
        },
      });
    },
    [
      setCircles,
      setEvents,
      setTotalCount,
      setBreadcrumbs,
      setSearchConditions,
      setIsLoading,
      setIsLoadingNextList,
      setIsLastPage,
      updateUrl,
    ]
  );

  const updateUrl = useCallback(
    ({
      categoryId,
      mainGenreKey,
      keyword,
      circleOrder,
      eventCondition,
      eventDate,
      page,
      prefKey,
    }) => {
      // =========== URL更新 ===========
      let pathname = '';
      // let pathname_params = "";
      // pathname_params +=
      //   categoryId === "" && mainGenreKey === "" && keyword !== ""
      //     ? `&keyword=${keyword}`
      //     : "";
      // pathname_params += circleOrder !== "" ? `&order=${circleOrder}` : "";
      // pathname_params +=
      //   eventCondition !== "" ? `&event_condition=${eventCondition}` : "";
      // pathname_params += eventDate ? `&event_date=${eventDate}` : "";
      // pathname_params += page !== "" && page !== 1 ? `&page=${page}` : "";
      // if (categoryId !== "") {
      //   pathname = `/search/${prefKey}/${categoryId}${pathname_params !== "" ? "?" + pathname_params : ""
      //     }`;
      // } else if (mainGenreKey !== "") {
      //   pathname = `/search/${prefKey}/services/${mainGenreKey}${pathname_params !== "" ? "?" + pathname_params : ""
      //     }`;
      // } else {
      //   pathname = `/search/${prefKey}${pathname_params !== "" ? "?" + pathname_params : ""
      //     }`;
      // }
      if (categoryId !== '') {
        pathname = `${
          props.hashedCompanyId ? '/community/' + props.hashedCompanyId : ''
        }/search/${prefKey}/${categoryId}`;
      } else if (mainGenreKey !== '') {
        pathname = `${
          props.hashedCompanyId ? '/community/' + props.hashedCompanyId : ''
        }/search/${prefKey}/services/${mainGenreKey}`;
      } else {
        pathname = `${
          props.hashedCompanyId ? '/community/' + props.hashedCompanyId : ''
        }/search/${prefKey}`;
      }

      const searchParams = new URLSearchParams(location.search);
      if (categoryId === '' && mainGenreKey === '' && keyword !== '') {
        searchParams.set('keyword', keyword);
      } else {
        searchParams.delete('keyword');
      }
      if (circleOrder !== '') {
        searchParams.set('order', circleOrder);
      } else {
        searchParams.delete('order');
      }
      if (eventCondition !== '') {
        searchParams.set('event_condition', eventCondition);
      } else {
        searchParams.delete('event_condition');
      }
      if (eventDate) {
        searchParams.set('event_date', eventDate);
      } else {
        searchParams.delete('event_date');
      }
      if (page !== '' && page !== 1) {
        searchParams.set('page', page);
      } else {
        searchParams.delete('page');
      }
      const searchParamsString = searchParams.toString();

      // アプリではWebViewウィンドウを開かないようにURLを変えない
      // if (typeof window !== 'undefined' && !props.isApp) {
      if (typeof window !== 'undefined') {
        // window.history.replaceState(null, null, encodeURI(pathname));
        const url = `${encodeURI(pathname)}${
          searchParamsString !== '' ? `?${searchParamsString}` : ''
        }`;
        window.history.replaceState(null, null, url);
      }

      // ===== googleアナリティクス =====
      // eslint-disable-next-line no-undef
      if (typeof window !== 'undefined') {
        if (typeof window.ga === 'function') {
          window.ga('send', 'pageview', pathname);
        } else if (typeof window.gtag === 'function') {
          window.gtag('event', 'page_view', { page_path: pathname });
        }
      }
    },
    []
  );

  // 検索条件変更
  const loadSearchResult = useCallback(
    ({
      prefKey = searchConditions.prefKey, // 指定がなければ、前と同じ条件
      keyword = searchConditions.keyword, // 必ず指定する(入力欄keywordDispと一致させる)
      circleOrder = searchConditions.circleOrder, // 指定がなければ、前と同じ条件
      eventCondition = searchConditions.eventCondition, // 指定がなければ、前と同じ条件
      eventDate = searchConditions.eventDate, // 指定がなければ、前と同じ条件
      timeSlot = searchConditions.timeSlot, // 指定がなければ、前と同じ条件
      timeSlotFrom = searchConditions.timeSlotFrom,
      timeSlotTo = searchConditions.timeSlotTo,
    }) => {
      if (isLoading) {
        return;
      }
      setIsLoading(true);
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      apiCall({
        page: 1,
        prefKey,
        keyword,
        circleOrder,
        eventCondition,
        eventDate,
        timeSlot,
        timeSlotFrom,
        timeSlotTo,
      });
    },
    [searchConditions, isLoading, setIsLoading, apiCall]
  );

  // スクロール時
  const loadNextList = useCallback(() => {
    if (isLoading || isLoadingNextList || isLastPage) {
      return;
    }
    setIsLoadingNextList(true);
    apiCall({
      ...searchConditions,
      page: searchConditions.page + 1,
    });
  }, [
    isLoading,
    isLoadingNextList,
    isLastPage,
    setIsLoadingNextList,
    apiCall,
    searchConditions,
  ]);

  const onChangePref = useCallback(
    (prefKey) => {
      loadSearchResult({ prefKey });
    },
    [loadSearchResult]
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const scrollUpFunc = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      };
      let startPos = 0;

      const scrollFunc = () => {
        const value = window.scrollY;
        if (value > window.innerHeight && value < startPos) {
          $('.scroll-up-btn').fadeIn();
        } else {
          $('.scroll-up-btn').fadeOut();
        }
        startPos = value;
      };

      scrollUpRef.current.addEventListener('click', () => scrollUpFunc());
      window.addEventListener('scroll', () => scrollFunc());

      return () => {
        scrollUpRef.current.removeEventListener('click', () => scrollUpFunc());
        window.removeEventListener('scroll', () => scrollFunc());
      };
    }
  }, [scrollUpRef]);

  // 検索結果のタイトル
  const searchTitle = useMemo(() => {
    const currentPref =
      props.countryPrefs &&
      props.countryPrefs.find((pref) => {
        return searchConditions.prefKey == pref.pref_key;
      });
    const dateUnit =
      searchConditions.eventDate !== null
        ? `${moment(searchConditions.eventDate).format('M')}月${moment(
            searchConditions.eventDate
          ).format('D')}日(${
            ['日', '月', '火', '水', '木', '金', '土'][
              moment(searchConditions.eventDate).day()
            ]
          }) `
        : '';
    const searchUnit =
      searchConditions.eventCondition !== ''
        ? 'サークルメンバー募集一覧'
        : 'サークル・イベント一覧';
    return `${dateUnit}${currentPref ? currentPref.name : '全国'}の${
      searchConditions.keyword ? '"' + searchConditions.keyword + '"の' : ''
    }${searchUnit}(${totalCount}件)`;
  }, [props, searchConditions, totalCount]);

  return (
    <React.Fragment>
      <div id="search-form-wrapper">
        {props.isSearchFormDisplay ? (
          <SearchForm
            categories={props.categories}
            keyword={searchConditions.keyword}
            loadSearchResult={loadSearchResult}
            eventCondition={searchConditions.eventCondition}
            eventDate={searchConditions.eventDate}
            timeSlot={searchConditions.timeSlot}
            companyId={props.companyId}
          />
        ) : (
          <div className="mb-4"></div>
        )}
      </div>
      <div id="search-result-wrapper">
        {isLoading ? (
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <SearchResult
            searchTitle={searchTitle}
            circles={circles}
            events={events}
            loadNextList={loadNextList}
            isLoadingNextList={isLoadingNextList}
            isLastPage={isLastPage}
            currentUser={props.currentUser}
            barColor={props.barColor}
            hashedCompanyId={props.hashedCompanyId}
          />
        )}
      </div>
      <div
        className="scroll-up-btn text-right"
        ref={scrollUpRef}
        style={
          props.currentUser &&
          props.currentUser.id &&
          searchConditions &&
          searchConditions.keyword
            ? {
                position: 'fixed',
                right: 0,
                bottom: 50,
                zIndex: 2,
                display: 'none',
              }
            : {
                position: 'fixed',
                right: 0,
                bottom: 0,
                zIndex: 2,
                display: 'none',
              }
        }
      >
        <img src="/images/scroll_up.png" width="64px" />
      </div>
    </React.Fragment>
  );
};

export default SearchBox;
